import { render, staticRenderFns } from "./crud-simples.vue?vue&type=template&id=4f18258e"
import script from "./crud-simples.vue?vue&type=script&lang=js"
export * from "./crud-simples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports